import ReactModal from 'react-modal';
import { Container, Head, Content } from './modal.styles.tsx';
import P from '../texts/p/P.tsx';
import Button from '../button/Button.tsx';
import Card from '../card/Card.tsx';
import Icon from '../icon/Icon.tsx';
import Spinner from '../Spinner/spinner.tsx';

const Modal = ({
  children,
  onSecondaryAction,
  secondaryVariant,
  secondaryText = '',
  onClose,
  isOpen,
  title,
  primaryVariant,
  onPrimaryAction,
  primaryActionDisabled = false,
  primaryText,
  loadingPrimaryBtn = false,
  showOverlay = true,
  width = '448px',
  overflow = 'auto',
}) => {
  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onClose}
      style={{
        overlay: {
          background: showOverlay ? 'rgba(0,0,0,0.65)' : 'transparent',
          zIndex: 1,
        },
        content: {
          alignSelf: 'center',
          borderRadius: '16px',
          width: width,
          height: 'auto',
          margin: '0 auto',
          padding: '0',
          overflow: overflow,
        },
      }}
      shouldFocusAfterRender={false}
      ariaHideApp={false}
    >
      <Container>
        <Content>
          <Head>
            <P type='3' variant='neutral' weight='bold' withMargin={false}>
              {title}
            </P>
            {onSecondaryAction && (
              <Icon
                name='cancel_outline'
                cursor='pointer'
                onClick={onClose}
                variant='neutral'
              />
            )}
          </Head>
          {children}
          <Card
            gap='16px'
            display='flex'
            margin={{ top: '4' }}
            justifyContent='flex-end'
            height='40px'
          >
            {secondaryText && (
              <Button variant={secondaryVariant} onClick={onSecondaryAction}>
                {secondaryText}
              </Button>
            )}
            <Button variant={primaryVariant} onClick={onPrimaryAction} disabled={primaryActionDisabled}>
              {loadingPrimaryBtn ? (
                <Spinner size='sm' variant='primary' />
              ) : (
                primaryText
              )}
            </Button>
          </Card>
        </Content>
      </Container>
    </ReactModal>
  );
};

export default Modal;
